import { Button, Heading, Stack, Text, ThemeFontSizeVariable } from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import StatusSuccess from "components/booking-status/status-icon/status-success";
import { Trans, useTranslation } from "react-i18next";

interface CancelBookingSuccessProps {
    isWaitList: boolean;
}

export function CancelBookingSuccess({ isWaitList }: CancelBookingSuccessProps) {
    const { t } = useTranslation();
    const { data: booking } = useWebBooking();
    const { data: settings } = useExternalBookingSettings();

    const guests = booking?.guests;
    const date = booking?.start.format("dddd D MMMM");
    const startTime = booking?.start.format("HH:mm");
    const endTime = settings?.hideEndTimeForGuest
        ? ""
        : `-${booking?.displayEndTime().format("HH:mm")}`;
    const isInquiry = booking?.anyNonCompleteInquirySubStatus();

    const getCancelModalTexts = () => {
        if (isWaitList) {
            return {
                title: t("waitList.waitListCanceledTitle"),
                message: (
                    <Trans
                        i18nKey="waitList.waitListCanceledMessage"
                        values={{ phoneNumber: settings?.phoneNumber }}
                        components={[
                            <Button
                                key="phone-link"
                                variant="link"
                                href={`tel:${settings?.phoneNumber}`}
                            />,
                        ]}
                    />
                ),
            };
        }

        if (isInquiry) {
            return {
                title: t("bookingRequest.cancelSuccess.title"),
                message: t("bookingRequest.cancelSuccess.message", {
                    guests,
                    date,
                    startTime,
                    endTime,
                }),
            };
        }

        return {
            title: t("bookingCanceledTitle"),
            message: t("bookingCancelSuccessMessage", { guests, date, startTime, endTime }),
        };
    };

    const { title, message } = getCancelModalTexts();
    return (
        <Stack alignItems="center" color="inherit">
            <StatusSuccess />
            <Stack>
                <Heading
                    as="h1"
                    fontWeight="500"
                    textAlign="start"
                    color="inherit"
                    fontSize={ThemeFontSizeVariable.XLarge}
                >
                    {title}
                </Heading>
                <Text textAlign="start" fontSize={ThemeFontSizeVariable.Large}>
                    {message}
                </Text>
            </Stack>
        </Stack>
    );
}
